const carCleaningService = {
  title: "Car Cleaning",
  icon: "🚗",
  rateCardKey: "car-cleaning",
  shortDescription:
    "Exterior wash, interior cleaning, dust removal, and basic detailing support.",
  longDescription:
    "Book one-time or recurring car cleaning support for exterior cleaning, interior dusting, vacuuming, and basic detailing assistance.",
  consultationNote:
    "Paint correction, ceramic coating, or premium detailing should be separate advanced services.",
  responsePromise:
    "Assignment depends on vehicle size, cleaning level, and location access.",
  warrantyPolicy:
    "Cleaning outcome depends on dirt level, stain type, and vehicle condition.",
  subServices: [
    {
      id: "car-basic-exterior",
      title: "Basic Exterior Cleaning",
      icon: "🫧",
      group: "Exterior",
      description:
        "Exterior body wash and wipe-down for standard passenger vehicles.",
      basePrice: 299,
      priceType: "fixed",
      duration: "30-45 mins",
      warranty: "Visit completion only",
      unit: "car",
    },
    {
      id: "car-interior-basic",
      title: "Basic Interior Cleaning",
      icon: "🧼",
      group: "Interior",
      description:
        "Basic dashboard, seat surface, and floor dust/vacuum cleaning support.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "30-60 mins",
      warranty: "Visit completion only",
      unit: "car",
    },
    {
      id: "car-full-clean",
      title: "Full Car Cleaning",
      icon: "✨",
      group: "Combo",
      description:
        "Combined exterior and interior basic cleaning package.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "Visit completion only",
      unit: "car",
    },
    {
      id: "car-monthly-plan",
      title: "Monthly Car Cleaning Plan",
      icon: "📅",
      group: "Recurring",
      description:
        "Recurring car cleaning plan for regular upkeep depending on frequency.",
      basePrice: 1499,
      priceType: "starts_at",
      duration: "Monthly plan",
      warranty: "Attendance/support policy",
      unit: "month",
    },
  ],
};

export default carCleaningService;